import { useEffect, useRef, useState,forwardRef, useImperativeHandle } from "react";

import {
  DeleteOutlined,
  EditFilled,
  EyeOutlined,
  MoreOutlined,
} from "@ant-design/icons";
import {
  Box,
  IconButton,
  Menu,
  MenuItem,
  Typography,
} from "@mui/material";
import { useNotification } from "../../../hooks/useNotification.js";
import { JournalAPIService } from "../../../services/api/JournalAPIService";
import { API_ERROR_MESSAGE, API_SUCCESS_MESSAGE, DATE } from "../../../shared/constants";
import dayjs from "dayjs";
import ConfirmationDialog from "../../common/ConfirmationDialog.js";
import CardTemplateEdit from "./CardTemplateEdit.js";
import ActionMenu from "../../../pages/Extra/ActionMenu.js";
import html2canvas from "html2canvas";
import DownloadBackdrop from "../../../pages/Memory_journal/DownloadBackdrop.js";


const CardTemplate = forwardRef((props,ref) => {
  const {
    journalId,
  headingText,
  author,
  date,
  bgColor = "#007aff",
  headingColor = "#ff92ac",
  textColor = "#ffffff",
  textSize = "20px",
  borderColor = "pink",
  headingMargin = "0%",
  imageTopLeft,
  widthSize = "72%",
  disableEye = false,
  editData = false,
  pageRefreshCallback,
  menuShow
  } = props;
  const { notifyError, notifySuccess } = useNotification();
  const [showEye, setShowEye] = useState(false);
  const [open, setOpen] = useState(false);
  const [editMode, setEditOpen] = useState(editData);
  const [anchorEl, setAnchorEl] = useState(null);
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const cardRef = useRef(null);
  const [downloading, setDownloading] = useState(false);
  const openMenu = Boolean(anchorEl);

  useImperativeHandle(ref, () => ({
      getCardElement: () => cardRef.current,
    }));

  const handleMenuClick = (action) => {
    switch (action) {
      case "edit":
        handleEdit();
        break;
      case "delete":
        handleDelete();
        break;
      case "effect":
        // handleOpenEditor(imgSrc, journalId);
        break;
      case "view":
        handleOpenDialog();
        break;
      case "save":
        handleDownloadImage();
        break;
      case "drag":

        console.log("Drag action triggered");
        // Optional: set some dragging state here
        break;
      default:
        break;
    }
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setShowEye(false);
  };

  const handleOpenDialog = () => setOpen(true);
  const handleCloseDialog = () => {
    setOpen(false);
    setEditOpen(false);
    setShowEye(false);
  };

  const handleEdit = () => {
    if (!disableEye) {
      setOpen(true);
    }
    setEditOpen(true);
    setShowEye(false);
  };

  const handleSubmit = () => {
    handleCloseDialog();
    setShowEye(false);
  };

  const handleDelete = () => {
    handleCloseDialog();
    setConfirmDialogOpen(true);
  };

  const handleCancelDelete = () => {
    setConfirmDialogOpen(false);
  };

  const handleConfirmDelete = () => {
    setConfirmDialogOpen(false);

    JournalAPIService.journalDelete(journalId)
      .then((response) => {
        notifySuccess(response.message || API_SUCCESS_MESSAGE.DELETED_SUCCESSFULLY);
        pageRefreshCallback();
      })
      .catch((errResponse) => {
        notifyError(
          errResponse?.response?.data?.message || API_ERROR_MESSAGE.INTERNAL_SERVER_ERROR
        );
      });
    handleCloseDialog();
  };

  const handleDownloadImage = async () => {
    if (!cardRef.current) return;

    try {
      setDownloading(true);

      const canvas = await html2canvas(cardRef.current, {
        useCORS: true,
        backgroundColor: null,
        scale: 8,
      });

      const hashCode = (str) => {
        let hash = 0;
        for (let i = 0; i < str.length; i++) {
          hash = (hash << 5) - hash + str.charCodeAt(i);
          hash |= 0;
        }
        return Math.abs(hash % 10000);
      };

      const shortCode = hashCode(journalId);

      const dataUrl = canvas.toDataURL("image/png");
      const link = document.createElement("a");
      link.href = dataUrl;
      link.download = `IMG_${shortCode}.png`;
      link.click();
      notifySuccess(API_SUCCESS_MESSAGE.DOWNLOAD_REEL);
    } catch (error) {
      console.error("Download failed:", error);
    } finally {
      setDownloading(false);
    }
  };

  return (
    <>
    {menuShow &&
     <IconButton
                        sx={{
                          position: "absolute",
                          top: 12,
                          right: 10,
                          color: "black",
                          zIndex: 1001,
                          width: { xs: "25px", sm: "30px", md: "30px" },
                          height: { xs: "25px", sm: "30px", md: "30px" },
                          "@media (max-width: 370px)": {
                            height: "20px",
                            width: "20px",
                          },
                          // bgcolor: "#ffffffc9",
                        }}
                        // onClick={handleMenuClick}
                      >
                 <ActionMenu action={handleMenuClick} show={true} drag={true} fullView={true}/>
                  </IconButton>
                  }
      <Box
        ref={cardRef}
        sx={{
          width: { xs: "100%", sm: "100%", md: "100%" },
          height: { xs: 260, sm: 348, md: 348 },
          "@media (max-width: 370px)": {
            height: disableEye ? 280 : 260,
          },
          "@media (min-width: 310px) and (max-width: 360px)": {
            height: 230,
          },
          marginTop: {
            xs: disableEye ? "10%" : "1%",
            sm: disableEye ? "6%" : "1%",
            md: disableEye ? "6%" : "1%",
          },
          bgcolor: bgColor,
          borderRadius: "16px",
          color: textColor,
          position: "relative",
          overflow: "hidden",
          textAlign: "center",
          fontFamily: "Arial, sans-serif",
        }}
        onMouseEnter={() => setShowEye(true)}
        onMouseLeave={() => setShowEye(false)}
      >
        {/* {showEye && !disableEye && (
          <IconButton
            onClick={handleOpenDialog}
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              display: "flex",
              alignItems: "center",
              zIndex: 1000,
              justifyContent: "center",
              backgroundColor: "rgba(0,0,0,0.5)",
              "&:hover": { backgroundColor: "rgba(0,0,0,0.5)" },
              borderRadius: 0,
            }}
          >
            <EyeOutlined style={{ fontSize: 30, color: "white" }} />
          </IconButton>
        )} */}

        {/* Dynamic Images */}
        {imageTopLeft && (
          <Box
            component="img"
            src={imageTopLeft}
            alt="top-left"
            sx={{
              width: "100%",
              height: { xs: disableEye ? "280px" : "260px", sm: "348px", md: "348px" },
              "@media (min-width: 310px) and (max-width: 360px)": {
                height: 230,
              },
            }}
          />
        )}

        {/* Heading */}
        <Typography
  sx={{
    width: widthSize,
    position: "absolute",
    top: headingMargin,
    left: "50%",
    transform: "translateX(-50%)",
    fontWeight: "bold",
    fontSize: textSize,
    "@media (min-width: 460px) and (max-width: 800px)": {
      top: author ? headingMargin : headingText?.length  <=30 ? "45%" : "40%"
          },

    // "@media (min-width: 310px) and (max-width: 360px)": {
    //   top: author ? headingMargin : headingText?.length  <=30 ? "45%" : "40%"
    //       },

    "@media (max-width: 370px)": {
      fontSize: headingText?.length < 20 ? "0.8rem" :"0.7rem",
      top: author ? headingMargin : headingText?.length  <=30 ? "45%" : "38%"
          },
    color: headingColor,
    textAlign: "center",
  }}
>
  {headingText}
  {author ? (
    <>
      <br />
      <br />
      {author}
    </>
  ) : null}
</Typography>

<Typography
  sx={{
    position: "absolute",
    bottom: 0,
    left: "50%",
    transform: "translateX(-50%)",
    fontSize: { xs: "0.7rem", sm: "0.9rem", md: "0.9rem" },
    color: textColor,
    textAlign: "center",
  }}
>
  {/* {dayjs(date).format(DATE.JOURNAL_FORMAT)} */}
</Typography>
      </Box>

      {/* Confirmation Dialog */}
      <ConfirmationDialog
        id="confirmation-dialog-description"
        open={confirmDialogOpen}
        title=""
        description="Are you sure you want to delete this memory?"
        onConfirm={handleConfirmDelete}
        onCancel={handleCancelDelete}
        confirmText="Delete"
        cancelText="Cancel"
        keepMounted={false}
        transition="up"
        loading={false}
      />

{open &&
      <CardTemplateEdit
      open={open}
      onClose={handleCloseDialog}
      journalId={journalId}
        headingText={headingText}
        author={author}
        date={date}
        bgColor={bgColor}
        headingColor={headingColor}
        textColor={textColor}
        textSize={textSize}
        borderColor={borderColor}
        headingMargin={headingMargin}
        imageTopLeft={imageTopLeft}
        widthSize={widthSize}
        disableEye={true}
        editData={editMode}
        pageRefreshCallback={pageRefreshCallback}
      />
      }

    <DownloadBackdrop downloading={downloading} />

    </>
  );
});

export default CardTemplate;
